import FullPageLoader from 'components/common/FullPageLoader';
import LiveClock from 'components/common/LiveClock';
import TemplateForm from 'components/template/TemplateForm';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchSingleTemplate } from 'slices/templateSlice';
import { templatesSelector } from 'slices/templateSlice';
import { fetchTemplatesListPage } from 'slices/templateSlice';

const UpdateTemplate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { singleTemplate, loader, error } = useSelector(templatesSelector);
    const { id } = useParams();

    useEffect(() => {
        if (id) {
            dispatch(fetchSingleTemplate(id));
        }
    }, [dispatch, id]);

    if (loader) return <FullPageLoader />;

    if (!singleTemplate) return <div>No interpreter found</div>;
    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                    <h2 className="main_heading">Update Template</h2>
                </div>
            </div>
            <TemplateForm item={singleTemplate} loader={loader} error={error} />
        </div>
    );
};

export default UpdateTemplate;
